
<template>
  <div class="link-button">
    <div class="link-button-bottom"></div>
    <div class="link-button-top" v-html="label"></div>
  </div>
</template>

<style>

.link-button {
  position: relative;
  height:40px;
  width: 160px;
  text-align: center;
  font-size: 14px;
  line-height: 40px;
  margin: 20px 0 0px;
  cursor: pointer;
}
.link-button-top {
  position: absolute;
  width: 100%;
  height:100%;
  background-color: #fff;
  border: 1px solid #000;
  transition: border-color 0.2s ease-out, color 0.2s ease-out;
  -webkit-transition: border-color 0.2s ease-out, color 0.2s ease-out;
}
.link-button-bottom {
  position: absolute;
  width: 100%;
  height:100%;
  -webkit-transform: translate3d(5px, 5px, 0);
  transform: translate3d(5px, 5px, 0);
  background-color: #000;
  transition: 0.2s ease-out;
  -webkit-transition: 0.2s ease-out;
}
.link-button-no-margin .link-button {
  margin-top: 0;
}

.link-button:hover > .link-button-top {
  border-color: #d1a699;
  color: #d1a699;
/*  -webkit-transform: rotateZ(1deg);
  transform: rotateZ(1deg);*/
}
.link-button:active > .link-button-top {
  background-color: #eddbd6;
  }
.link-button:hover > .link-button-bottom {
  background-color: #ec7d8d;
  -webkit-transform: rotateZ(1deg) translate3d(8px, 8px, 0);
  transform: rotateZ(1deg) translate3d(8px, 8px, 0);
}

@media (min-width: 768px) {
  .link-button {
    margin: 20px 0 0px;
  }
}

</style>

<script>
// import Vue from 'vue'

export default {
  props: ['label'],
  data: function () {
    return {
      paddingTop: 0
    }
  },
  methods: {
    goToLink: function () {
    }
  },
  mounted: function () {
  }
}
</script>




// WEBPACK FOOTER //
// LinkButton.vue?44a027a8